import { render, staticRenderFns } from "./brandItem.vue?vue&type=template&id=4663b4f7"
import script from "./brandItem.vue?vue&type=script&lang=js"
export * from "./brandItem.vue?vue&type=script&lang=js"
import style0 from "./brandItem.vue?vue&type=style&index=0&id=4663b4f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports